import Component from 'D:/AUTOMFL/UniApp/uniAdmin/components/uni-data-menu/uni-data-menu.vue'
wx.createComponent(Component)